import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
    buttonContainer: {
        //zIndex: 10,
    },
}))

export default useStyles;